import Vue from 'vue'
import Vuex from 'vuex'

import base from './base/base'
import auth from './auth/auth'
import admin from './admin/admin'
import users from './user/users'
import students from './student/students'
import personal from './personal/personal'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    base,
    auth,
    admin,
    users,
    students,
    personal
  }
})
